<template>
  <section class="mx-4.5 py-5 md:py-12">
    <div class="mx-auto max-w-content-container">
      <div
        class="mx-auto flex flex-col-reverse items-center gap-x-12 md:flex-row lg:w-10/12"
      >
        <div class="md:w-1/2">
          <img
            class="aspect-[562/324] w-full rounded-xl border border-grey-600 bg-black/10"
            alt="Benchmark and ICE logos"
            src="https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1744233605/assets/ice/ice-cobalt/logo-ice_kfiwjy.png"
          />
        </div>

        <div
          class="mb-10 mt-5 flex flex-col gap-5 text-paragraph-xl md:my-0 md:w-1/2 md:gap-6"
        >
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts"></script>
